import { Link } from "react-router-dom";
import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";
import SEO from "@/components/marketing/SEO";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { blogPosts } from "@/data/blogPosts";
import { ArrowRight } from "lucide-react";

const Blog = () => {
  const collectionData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Blog Piktable — gestion restaurant Suisse",
    description:
      "Conseils et astuces pour la gestion de restaurant, les réservations en ligne et l'optimisation de votre établissement en Suisse romande.",
    url: "https://piktable.ch/blog",
    publisher: {
      "@type": "Organization",
      name: "Piktable",
      url: "https://piktable.ch",
    },
  };

  // ItemList = signal fort pour Google sur les pages d'index : énumère
  // explicitement les articles disponibles. Aide à passer de "Discovered,
  // currently not indexed" à "Indexed".
  const itemListData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Articles du blog Piktable",
    numberOfItems: blogPosts.length,
    itemListElement: blogPosts.map((post, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      url: `https://piktable.ch/blog/${post.slug}`,
      name: post.title,
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Blog gestion restaurant — conseils réservation Suisse romande"
        description="Conseils pratiques pour gérer un restaurant en Suisse : réduire les no-shows, optimiser les réservations en ligne, comparer les commissions, organiser le plan de salle. Articles par l'équipe Piktable, Lausanne."
        canonical="/blog"
        structuredData={[collectionData, itemListData]}
      />

      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-8">
          {/* Hero */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="font-playfair text-4xl md:text-5xl font-bold text-foreground mb-4">
              Blog Piktable
            </h1>
            <p className="text-lg text-muted-foreground">
              Conseils pratiques pour optimiser la gestion de votre restaurant
              et simplifier vos réservations en Suisse romande.
            </p>
          </div>

          {/* Articles grid */}
          {blogPosts.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {blogPosts.map((post) => (
                <Link key={post.slug} to={`/blog/${post.slug}`}>
                  <Card className="h-full hover:shadow-lg transition-shadow duration-300 border-border">
                    <CardHeader className="pb-3">
                      <div className="flex items-center justify-between mb-2">
                        <Badge variant="secondary" className="text-xs">
                          {post.category}
                        </Badge>
                        <span className="text-xs text-muted-foreground">
                          {post.date}
                        </span>
                      </div>
                      <h2 className="font-playfair text-xl font-bold text-foreground leading-tight">
                        {post.title}
                      </h2>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground text-sm mb-4 line-clamp-3">
                        {post.excerpt}
                      </p>
                      <span className="text-primary text-sm font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                        Lire l'article <ArrowRight className="w-4 h-4" />
                      </span>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-muted-foreground text-lg">
                Les articles arrivent bientôt. Restez connectés !
              </p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Blog;
